<template>
  <AdminLayout>
    <MainIndex />
    <div class="pb-16"></div>
  </AdminLayout>
</template>

<script>
// @ is an alias to /src
import AdminLayout from '@/layouts/AdminLayout.vue';
import MainIndex from '@/components/admin/invoices/MainIndex.vue';

export default {
  name: 'InvoicesView',
  components: {
    AdminLayout,
    MainIndex,
  },
};
</script>
